export enum DuplicableElementPartialPathsEnum {
    "GR-Organisations" = "UBLExtensions.UBLExtension.ExtensionContent.EformsExtension.Organizations.Organization",
    "GR-LotResult" = "UBLExtensions.UBLExtension.ExtensionContent.EformsExtension.NoticeResult.LotResult",
    "GR-Lot" = "ProcurementProjectLot",
    "GR-LotTender" = "UBLExtensions.UBLExtension.ExtensionContent.EformsExtension.NoticeResult.LotTender",
    "GR-TenderingParty" = "UBLExtensions.UBLExtension.ExtensionContent.EformsExtension.NoticeResult.TenderingParty",
    "GR-SettledContract" = "UBLExtensions.UBLExtension.ExtensionContent.EformsExtension.NoticeResult.SettledContract"
}
